<div class="searchdiv">
  <div class="card screen-wrapper">
    <app-shared-header-div [screentitle] ="screentitle" [Errmessage]="Errmessage" [headerDivName]="headerDivName"></app-shared-header-div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 4% 2% 2%">
                  <div>
                    <div>
                      <app-shared-instruct-div></app-shared-instruct-div>
                      <div class="col-md-3">
                        <label>INTERMILES Number </label>
                        <input [(ngModel)]="search_details.jp_number" maxlength="11" (keypress)="keypresshandler($event)"
                          type="text" (input)="isEmpty()" class="form-control m-input"
                          placeholder="Enter INTERMILES Number" (keyup)="jpNumberValidation();" />
                        <span id="JpErr"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">Airline PNR</label>
                        <input [(ngModel)]="search_details.airlinepnr" type="text" class="form-control m-input"
                          placeholder="Enter Airline PNR" (input)="isEmpty()" (keyup)="pnrValidation();"
                          style="text-transform: uppercase" maxlength="6" />
                        <span id="pnrNO"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">Booking Reference No</label>
                        <input [(ngModel)]="search_details.order_id" type="text" class="form-control m-input"
                          maxlength="18" placeholder="Enter Booking Reference No" (keyup)="orderValidation();"
                          (blur)="orderValidationOnBlur()" (input)="isEmpty()" style="text-transform: uppercase" />
                        <span id="orErr"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">Supplier ID</label>
                        <input [(ngModel)]="search_details.emt" type="text" class="form-control m-input"
                          placeholder="Enter Supplier ID" style="text-transform: uppercase" (input)="isEmpty()"
                          (keyup)="EMTidValidation();" />
                        <span id="EMT_id_err"></span>
                      </div>
                      <div class="clr"></div>
                      <div class="divider" style="height:0px !important"></div>
                      <div class="col-md-3">
                        <label class="">Ticket No </label>
                        <input [(ngModel)]="search_details.Ticket_No" type="text" class="form-control m-input"
                          placeholder="Enter Ticket No" maxlength="15" (input)="isEmpty()" />
                        <span id="orErr"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">First Name</label>

                        <input [(ngModel)]="search_details.first_name" type="text" class="form-control m-input"
                          placeholder="Enter First Name" (input)="isEmpty()" (keyup)="fnameValidation();" />
                        <span id="fnErr"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">Last Name</label>
                        <input [(ngModel)]="search_details.last_name" type="text" class="form-control m-input"
                          placeholder="Enter Last Name" (input)="isEmpty()" (keyup)="lnameValidation();" />
                        <span id="lnErr"></span>
                      </div>
                      <div class="clr"></div>
                      <div class="divider" style="height:0px !important"></div>
                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input id="did" #input3 matInput [(ngModel)]="search_details.bookingdate_from"
                            [matDatepicker]="pickerFrom1" (dateChange)="toggleDisable2();incresedate();isEmpty();"
                            [disabled]="bookingdate" autocomplete="off" placeholder="From Cancel Booking Date" readonly
                            [max]="myDate" />
                          <mat-datepicker-toggle matSuffix [for]="pickerFrom1"></mat-datepicker-toggle>
                          <mat-datepicker #pickerFrom1></mat-datepicker>
                        </mat-form-field>

                        <button type="button" class="close opa" (click)="reset3(); checkStatus1()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br />
                      </div>
                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input [min]="final" #input4 matInput [disabled]="bookingdate"
                            [(ngModel)]="search_details.bookingdate_to" [matDatepicker]="pickerTO"
                            (dateChange)="isEmpty();" autocomplete="off" placeholder="To cancel Booking Date" readonly
                            [max]="newDate" />
                          <mat-datepicker-toggle matSuffix [for]="pickerTO"></mat-datepicker-toggle>
                          <mat-datepicker #pickerTO></mat-datepicker>
                        </mat-form-field>
                        <button type="button" class="close opa" (click)="reset4(); checkStatus1()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clr"></div>
              <div class="sdiv">
                <div class="btn clear-button button-margin">
                  <button class="btn btn-primary  commonbutt" [disabled]="IsEmptyVal == false || IsErr == true "
                    (click)="getFcrData(0)" type="button">
                    <em class="fa fa-search "></em>&nbsp;Search
                  </button>

                  <button class="btn btn-primary  commonbutt" [disabled]="IsEmptyVal == false || IsErr == true "
                    (click)="getFcrData(1)" type="button">
                    <em class="fa fa-search "></em>&nbsp;Download
                  </button>
                </div>
              </div>
              <div class="errwrap">
                <div class="errdiv1" id="err"></div>
              </div>
              <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list != '' || search_detail_list != 0"
                [hidden]="searchlist">
                <table aria-describedby="fcrBookingDetails" class="table table-striped" *ngIf="!loader"
                  [mfData]="serachtabledata" [mfRowsOnPage]="6">
                  <thead>
                    <tr>
                      <th scope="col">Booking Reference No</th>
                      <th scope="col">INTERMILES Number</th>
                      <th scope="col">Passenger Name</th>
                      <th scope="col">Booking Date</th>
                      <th scope="col">Ticket No</th>
                      <th scope="col">EMT</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="link" *ngFor="
                                    let item of (search_detail_list
                                      | paginate: { itemsPerPage: 10, currentPage: p ,totalItems:totalItems })
                                  ">
                      <td>
                        {{item.IM_BOOKING_ID.length == 18 ? '' : 'JPUB'}}{{item.IM_BOOKING_ID}}
                      </td>

                      <td *ngIf="item.JP_NUMBER == undefind || item.JP_NUMBER == null || item.JP_NUMBER == ''">
                        NA
                      </td>
                      <td *ngIf="item.JP_NUMBER != undefind && item.JP_NUMBER != null && item.JP_NUMBER != ''">
                        {{ item.JP_NUMBER }}
                      </td>

                      <td>{{item.TRAVELLER_NAME}}</td>
                      <td>
                        {{ item.BOOKING_DATE }} {{ item.BOOKING_TIME }}
                      </td>

                      <td *ngIf="item.TICKET_NO == undefind || item.TICKET_NO == null || item.TICKET_NO == ''">NA</td>
                      <td *ngIf="item.TICKET_NO != undefind && item.TICKET_NO != null && item.TICKET_NO != '' ">
                        {{ item.TICKET_NO}}</td>

                      <td>
                        {{ item.SUPPLIER_ID }}
                      </td>

                      <td>
                        {{item.STATUS}}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="7">
                        <pagination-controls (pageChange)="pageCount($event)" total-items="totalItems">
                        </pagination-controls>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list == '' || search_detail_list == 0">
                <h1 style="text-align:center" *ngIf="noresult != ''" id="noresulrErr">
                  {{ noresult }}
                </h1>
              </div>
              <div *ngIf="loader">
                <div style="margin: 0 auto; text-align: center;">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>